/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Statement_Tree_Csv_ExportInputs */

const en_statement_tree_csv_export = /** @type {(inputs: Statement_Tree_Csv_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export CSV`)
};

const nl_statement_tree_csv_export = /** @type {(inputs: Statement_Tree_Csv_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CSV exporteren`)
};

/**
* | output |
* | --- |
* | "Export CSV" |
*
* @param {Statement_Tree_Csv_ExportInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const statement_tree_csv_export = /** @type {((inputs?: Statement_Tree_Csv_ExportInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statement_Tree_Csv_ExportInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_statement_tree_csv_export(inputs)
	return en_statement_tree_csv_export(inputs)
});